<template>
  <v-dialog v-model="showDialog" max-width="750" click:outside="" persistent>
    <v-card>
      <v-card-title>
        <h3>{{ $vuetify.t('$vuetify.AdminUsers.confirmResetPassword', this.username) }}</h3>
      </v-card-title>
      <v-card-text v-if="newPassword !== ''">
        <v-alert :value="true" type="info">
          <b>{{ $vuetify.t('$vuetify.AdminUsers.newPassword') }}:</b>
          <h2>{{ newPassword }}</h2>
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="error"
          v-if="newPassword === ''"
          @click="resetPassword"
        >{{ $vuetify.t('$vuetify.AdminUsers.resetPassword') }}
        </v-btn>
        <v-btn @click="showDialog = false" v-if="newPassword == ''">
          {{ $vuetify.t('$vuetify.AdminUsers.formCancel') }}
        </v-btn>
        <v-btn @click="showDialog = false; newPassword = ''" v-if="newPassword !== ''">
          {{ $vuetify.t('$vuetify.Form.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '../../api'

export default {
  name: 'UserPasswordResetDialog',
  props: {
    show: Boolean,
    user: Object
  },

  data: function () {
    return {
      newPassword: '',
      username: '',
      editingId: null
    }
  },

  beforeMount: function () {
    // setting user data
    this.username = this.user.username
    this.editingId = this.user.id
  },

  computed: {
    showDialog: {
      get () {
        return this.show
      },
      set (value) {
        this.$emit('handleClose', value)
      }
    }
  },

  methods: {
    resetPassword: function () {
      api.user.resetPassword(this.$store.getters.selected_school, this.editingId).then(res => {
        this.newPassword = res.data['new_password']
      })
    }
  }
}
</script>

<style scoped>

</style>
